/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageRoles } from '../../models/manage-roles';

export interface PracticesGetAllGroups$Params {
  practiceId: string | null;
}

export function practicesGetAllGroups(http: HttpClient, rootUrl: string, params: PracticesGetAllGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageRoles>>> {
  const rb = new RequestBuilder(rootUrl, practicesGetAllGroups.PATH, 'get');
  if (params) {
    rb.path('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ManageRoles>>;
    })
  );
}

practicesGetAllGroups.PATH = '/practices/{practiceId}/groups';
